import axios from "axios";
import {
    GET_INSTANT_RATE_LOCATION_FAILURE,
    GET_INSTANT_RATE_LOCATION_SUCCESS,
    ADD_OBJECT_INSTANT_SEARCH,
    REMOVE_OBJECT_INSTANT_SEARCH,
    UPDATE_INSTANT_RATE_SWAP,
    UPDATE_SEARCH_INSTANT_RATE_DATA,
    UPDATE_SEARCH_INSTANT_RATE_DATE,
    UPDATE_VALUE_BLANK,
    GET_ALL_INCOTERM,
    GET_ALL_INCOTERM_SUCCESS,
    GET_INSTANT_SEARCH_RESULT_TYPE,
    UPDATE_QUOTATION_RESULT_DETAILS,
    CONFIRM_PREVIEW_DATA,
    QUOTATION_RESULT_UPDATE,
    QUOTATION_RESULT_SELECTED_BLANK,
    QUOTATION_RESULT_SELECTED,
    POST_INSTANT_SEARCH_LOADER,
    BLANK_INSTANT_SEARCH,
    GET_AIR_LOCATION_TYPE_SUCCESS,
    SEARCH_RESULT_FILTER_UPDATE,
    CLEAR_SEARCH_RESULT_FILTER,
    GET_INSTANT_SEARCH_RESULT_ID,
    GET_INSTANT_AIR_SEARCH_RESULT_DETAILS,
    INSTANT_RATE_ACTIVE_TAB_TYPE,
    QUOTATION_RESULT_REMARK_UPDATE,
    POST_INSTANT_AIR_SEARCH_DATA_SUCCESS,
    FILTER_INSTANT_RATE,
    QUOTATION_RESULT_SELECTED_TENANT,
    QUOTATION_RESULT_SELECTED_SUCCESS,
    GET_DEFAULT_MARGIN,
    GET_INSTANT_SEARCH_JSON,
    INSTANT_AIR_CHECKED_DATA_UPDATE,
    SMART_QUOTATION_VALUE_UPDATE,
    SMART_QUOTATION_TARIFF_DETAILS_VALUE_UPDATE,
    GET_INSTANT_BOOKING_REQUEST_DATA_SUCCESS,
    GET_INSTANT_BOOKING_REQUEST_DATA_LOADER,
    RESET_SHIPMENT_FORM_DATA,
} from "./actionType"
import { Get_File_URL, STORAGE_BASE_URL } from "../../helpers/url_helper";
import { inputArr } from "../../pages/InstantRate/OceanFreightResult/SearchResultComp";
import {hasInstantDomesticsRatePermission} from "../../common/data/ApplicationModules";

const INIT_STATE = {
    // $instantActiveTab: {
    //     main: hasInstantDomesticsRatePermission() ? 'domestic' : 'international',
    //     sub: hasInstantDomesticsRatePermission() ? 'dom_air' : 'FCL'
    // },
    $instantActiveTab: {
        main: 'ocean_freight',
        sub: 'FCL',
    },
    searchForm: {
        // customer_name: '',
        // service_type: '',
        // shipping_by: '',
        // cargo_weight: { weight: "MT",value: ''},
        quote_currency: {value: 'US DOLLAR', label: 'USD', currencyCode: 'USD', id: 3, version: 0},
        cargo_type: { value: "GENERAL", label: "GENERAL", id: 1, version: 0, cargoTypeCode: "GEN" },
        dom_air_cargo_type: { value: "GENERAL", label: "GENERAL", id: 6, version: 0 },
        cargo_value: { currency: {value: 'US DOLLAR', label: 'USD', currencyCode: 'USD', id: 3, version: 0}, value: '' },
        flight_mode: { label: "GCR", value: "GCR" },
        // incoterm: '',
        bookingMode: { label: "MAWB", value: "MAWB" },
        customerName: '',
        container_type: {},
        // shipment_details: "",
        cargo_date: '',
        location_from: '',
        location_to: '',
        alternate_route: false,
        menuType: '',
    },
    instantRateLocation: [],
    incoterm: [],
    airLocation: [],

    instantInquiryId: '',
    instantSearchResult: [],
    instantSearchResultCopy: [],
    is_tenantFclQuotationSummary: false,
    quote_selected_data: [],
    quote_selected_tenantdata: {},

    result_loader: false,
    error: null,
    airSearchData: [],
    filter_instant_rate: inputArr,
    defaultMargin: 10,
    tariffDetails: [],
    smartQuotationsValues: {
        quote_currency: {value: 'US DOLLAR', label: 'USD', currencyCode: 'USD', id: 3, version: 0}
    },
    instantBookingRequestData: [],
    instantBookingRequestLoader: false
};

const instantRate = (state = INIT_STATE, action) => {
    switch (action.type) {
        case RESET_SHIPMENT_FORM_DATA:
            return {
                ...state,
                searchForm: {
                    ...state.searchForm,
                    cargo_value: '',
                    commodity: null,
                    incoterms: null,
                    shipment_details: []
                },
                quote_selected_data: [], // Clear quote data to prevent displaying previous values
                quote_selected_tenantdata: {} // Clear tenant data as well
            };
        case GET_INSTANT_BOOKING_REQUEST_DATA_LOADER:
            return {
                ...state,
                instantBookingRequestLoader: action.payload
            }
        case GET_INSTANT_BOOKING_REQUEST_DATA_SUCCESS:
            return {
                ...state,
                instantBookingRequestData: action.payload
            }
        case SMART_QUOTATION_VALUE_UPDATE:
            return {
                ...state,
                smartQuotationsValues: {
                    ...state.smartQuotationsValues,
                    ...action.payload,
                },
            };
        case SMART_QUOTATION_TARIFF_DETAILS_VALUE_UPDATE:
            //console.log(SMART_QUOTATION_TARIFF_DETAILS_VALUE_UPDATE, action.payload);
            const { header, chargeId, parentData, breakdown } = action.payload;

            const existingTariffIndex = state.tariffDetails.findIndex((item) => item.header === header);

            if (existingTariffIndex === -1) {
                // 🟢 Parent doesn't exist → Add parent with child
                return {
                    ...state,
                    tariffDetails: [
                        ...state.tariffDetails,
                        {
                            ...parentData,
                            header,
                            chargeId,
                            fclTariffBreakDowns: [breakdown]
                        }
                    ]
                };
            } else {
                // 🟡 Parent exists
                const updatedDetails = [...state.tariffDetails];
                const parent = updatedDetails[existingTariffIndex];

                const breakdownIndex = parent.fclTariffBreakDowns.findIndex(
                    (b) => b.id === breakdown.id
                );

                const updatedBreakdowns =
                    breakdownIndex !== -1
                        ? parent.fclTariffBreakDowns.map((b, i) =>
                            i === breakdownIndex ? { ...b, ...breakdown } : b
                        )
                        : [...parent.fclTariffBreakDowns, breakdown];

                updatedDetails[existingTariffIndex] = {
                    ...parent,
                    ...parentData, // optional parent update
                    fclTariffBreakDowns: updatedBreakdowns
                };

                return {
                    ...state,
                    tariffDetails: updatedDetails
                };
            }

        case INSTANT_RATE_ACTIVE_TAB_TYPE:
            return {
                ...state,
                $instantActiveTab: {
                    main: action.payload.main,
                    sub: action.payload.sub
                }
            }

        case UPDATE_INSTANT_RATE_SWAP:
            return {
                ...state,
                searchForm: {
                    ...state.searchForm,
                    location_to: state.searchForm.location_from,
                    location_from: state.searchForm.location_to
                }
            }

        case ADD_OBJECT_INSTANT_SEARCH:
            return {
                ...state,
                searchForm: {
                    ...state.searchForm,
                    [action.payload]: ''
                }
            }
        case REMOVE_OBJECT_INSTANT_SEARCH:
            const objectCopy = { ...state.searchForm };
            delete objectCopy[action.payload];
            return {
                ...state,
                searchForm: {
                    ...objectCopy
                }
            }

        case UPDATE_VALUE_BLANK:
            return {
                ...state,
                searchForm: {
                    ...state.searchForm,
                    [action.payload]: ''
                }
            }
        case BLANK_INSTANT_SEARCH:
            return {
                ...state,
                searchForm: {
                    cargo_type: { value: "GENERAL", label: "GENERAL", id: 1, version: 0 },
                    dom_air_cargo_type: { value: "GENERAL", label: "GENERAL", id: 6, version: 0 },
                    cargo_value: { currency: {value: 'US DOLLAR', label: 'USD', currencyCode: 'USD', id: 3, version: 0}, value: '' },
                    quote_currency: {value: 'US DOLLAR', label: 'USD', currencyCode: 'USD', id: 3, version: 0},
                    customerName: '',
                    container_type: {},
                    cargo_date: '',
                    location_from: '',
                    location_to: '',
                    flight_mode: { label: "GENERAL", value: "GENERAL" },
                    alternate_route: false,
                    menuType: '',
                }
            }

        case UPDATE_SEARCH_INSTANT_RATE_DATA:
            const { item, name } = action.payload;
            return {
                ...state,
                searchForm: {
                    ...state.searchForm,
                    [name]: item
                }
            }

        case UPDATE_SEARCH_INSTANT_RATE_DATE:
            const { arrItem } = action.payload
            let newObj = {
                ...state,
                searchForm: {
                    ...state.searchForm,
                    cargo_date: [...arrItem],
                }
            }
            return state = newObj

        // Fetch all dropdown api
        case GET_INSTANT_RATE_LOCATION_SUCCESS:
            return {
                ...state,
                instantRateLocation: action.payload,
                error: null,
            };
        case GET_INSTANT_RATE_LOCATION_FAILURE:
            return {
                ...state,
                instantRateLocation: [],
                error: action.payload,
            };
        case GET_ALL_INCOTERM_SUCCESS:
            let existingObj = action.payload.content?.find((obj) => obj.name === "EX WORKS")
            return {
                ...state,
                incoterm: action.payload.content.map((item) => {
                    return {
                        value: item.id,
                        label: item.name,
                        version: item.version
                    }
                }),
                error: null,
                searchForm: {
                    ...state.searchForm,
                    incoterm: {
                        value: existingObj?.id,
                        label: existingObj?.name,
                        version: existingObj?.version
                    }
                }
            };

        case GET_AIR_LOCATION_TYPE_SUCCESS:
            return {
                ...state,
                airLocation: action.payload.content?.map((item, index) => {
                    return {
                        value: item.name,
                        label: `${item.code} - ${item.name}`,
                        code: item.code,
                        id: item.id,
                        version: item.version,
                        country: item.country,
                        city: item.city
                    }
                })
            }

        // ------------------ search Result
        case GET_INSTANT_SEARCH_RESULT_ID:
            return {
                ...state,
                instantInquiryId: action.payload,
            }

        case GET_DEFAULT_MARGIN:
            return {
                ...state,
                defaultMargin: action.payload,
            }

        case POST_INSTANT_AIR_SEARCH_DATA_SUCCESS:
            return {
                ...state,
                airSearchData: action.payload.map((item, index) => {
                    let url = item.airLineSummary?.logoPath || '';
                    let fileName = url;
                    //const base64Encoded = window.btoa(fileName);
                    return {
                        id: index + 1,
                        quote_id: 'air_' + (index + 1),
                        tenantId: item.tenantId || 0,
                        flightname: item.airLineSummary?.flightName,
                        flightno: item.airLineSummary?.flightNumber,
                        agentname: item.airLineSummary?.agentName,
                        carrierLogo: `${STORAGE_BASE_URL}${fileName}`,
                        originDetails: {
                            portname: item.airLineSummary?.originAirportName,
                            time: item.airLineSummary?.etd ? item.airLineSummary?.etd.slice(0, 5) : null,
                            date: item.airLineSummary?.cargoDate
                        },
                        destinationDetails: {
                            portname: item.airLineSummary?.destinationAirportName,
                            time: item.airLineSummary?.eta ? item.airLineSummary?.eta.slice(0, 5) : null,
                            date: item.airLineSummary?.cargoDate
                        },
                        freightMode: item.airLineSummary?.cargoMode,
                        cargoType: item.airLineSummary?.cargoType,
                        oceanTransitTime: item.airLineSummary?.totalTravelTime,
                        airFreightCharges: item?.airFreightCharges,
                        totalCost: item?.airLineSummary?.totalCost,
                        tariffDetails: [
                            {
                                header: "Pickup_Charges",
                                fclTariffBreakDowns: []
                            },
                            {
                                header: "Origin_Airport_Charges",
                                fclTariffBreakDowns: item?.originAirportCharges || [],
                                selected: true,
                            },
                            {
                                header: "Air_Freight_Charges",
                                fclTariffBreakDowns: (item?.airFreightCharges ? [item.airFreightCharges] : []).concat(item?.airLineCharges || []),
                                selected: true,
                            },
                            {
                                header: "Destination_Airport_Charges",
                                fclTariffBreakDowns: item?.destinationAirportCharges || [],
                                selected: true,
                            },
                            {
                                header: "Delivery_Charges",
                                fclTariffBreakDowns: []
                            }
                        ]
                    }
                })
            };


        case GET_INSTANT_SEARCH_RESULT_TYPE:
            let newResultArray = [];
            let isPortToPort = (state.searchForm?.location_from.locationType === 'PORT' && state.searchForm?.location_to.locationType === 'PORT');
            if (action.payload.fclInquiryResults !== undefined) {
                newResultArray = action.payload.fclInquiryResults;
            } else {
                newResultArray = action.payload;
            }
            return {
                ...state,
                instantSearchResult: action.payload,
                instantSearchResultCopy: newResultArray?.map((item, index) => {
                    let url = item.carrierLogo || '';
                    let fileName = url?.substring(url?.lastIndexOf('/') + 1, url?.length);
                    //const base64Encoded = window.btoa(fileName);
                    return {
                        ...item,
                        quote_id: `quote_${index}`,
                        carrierLogo: `${STORAGE_BASE_URL}${fileName}`,
                        tariffDetails: item.tariffDetails.map((item) => {
                            if (isPortToPort) {
                                if (item.header === 'ORIGIN_INLAND_CHARGES' || item.header === 'DESTINATION_INLAND_CHARGES') {
                                    return {
                                        ...item,
                                        selected: false
                                    }
                                } else {
                                    return {
                                        ...item,
                                        selected: true
                                    }
                                }
                            } else {
                                if (item.header === 'DESTINATION_INLAND_CHARGES') {
                                    return {
                                        ...item,
                                        selected: false
                                    }
                                } else {
                                    return {
                                        ...item,
                                        selected: true
                                    }
                                }
                            }
                        })
                    }
                }),
            }
        case UPDATE_QUOTATION_RESULT_DETAILS:
            return {
                ...state,
                instantSearchResultCopy: state.instantSearchResultCopy.map((item, index) => {
                    if (item.quote_id === action.payload.id) {
                        return {
                            ...item,
                            tariffDetails: [...item.tariffDetails].map((detail) => {
                                if (detail.header === action.payload.name) {
                                    return {
                                        ...detail,
                                        selected: action.payload.value
                                    };
                                }
                                return detail;
                            })
                        };
                    }
                    return item;
                }),
            }
        case INSTANT_AIR_CHECKED_DATA_UPDATE:
            //console.log("Before Update:", JSON.stringify(state.airSearchData, null, 2));
            const airCheckNewState = {
                ...state,
                airSearchData: state.airSearchData.map((item) => {
                    if (item.quote_id === action.payload.id) {
                        return {
                            ...item,
                            tariffDetails: item.tariffDetails.map((detail) => {
                                if (detail.header === action.payload.name) {
                                    return {
                                        ...detail,
                                        selected: action.payload.value
                                    };
                                }
                                return detail;
                            })
                        };
                    }
                    return item;
                }),
            };
            //console.log("After Update:", JSON.stringify(airCheckNewState.airSearchData, null, 2));
            return airCheckNewState;
        case SEARCH_RESULT_FILTER_UPDATE:
            return {
                ...state,
                instantSearchResultCopy: state.instantSearchResultCopy.map((item, index) => {
                    return {
                        ...item,
                        tariffDetails: item.tariffDetails.map((subitem, i) => {
                            if (action.payload.obj?.includes(subitem.header)) {
                                return {
                                    ...subitem,
                                    selected: true
                                }
                            } else if (!action.payload.obj?.includes(subitem.header)) {
                                return {
                                    ...subitem,
                                    selected: false
                                }
                            }
                            return subitem
                        })
                    }
                })
            }
        case CLEAR_SEARCH_RESULT_FILTER:
            let isClearPortToPort = (state.searchForm?.location_from.locationType === 'PORT' && state.searchForm?.location_to.locationType === 'PORT');
            return {
                ...state,
                instantSearchResultCopy: state.instantSearchResultCopy.map((item, index) => ({
                    ...item,
                    tariffDetails: item.tariffDetails.map((subitem, i) => {
                        if (isClearPortToPort) {
                            if (subitem.header === 'ORIGIN_INLAND_CHARGES' || subitem.header === 'DESTINATION_INLAND_CHARGES') {
                                return {
                                    ...subitem,
                                    selected: false
                                }
                            } else {
                                return {
                                    ...subitem,
                                    selected: true
                                }
                            }
                        } else {
                            return {
                                ...subitem,
                                selected: true
                            }
                        }
                    })
                }))
            }
        case QUOTATION_RESULT_SELECTED:
            return {
                ...state,
                quote_selected_data: action.payload,
            }
        case QUOTATION_RESULT_SELECTED_SUCCESS:
            return {
                ...state,
                is_tenantFclQuotationSummary: action.payload
            }
        case GET_INSTANT_SEARCH_JSON:
            return {
                ...state,
                searchForm: action.payload
            }
        case QUOTATION_RESULT_SELECTED_TENANT:
            return {
                ...state,
                quote_selected_tenantdata: action.payload
            }

        case QUOTATION_RESULT_UPDATE:
            const newArray = [...state.quote_selected_data];
            const existingIndex = newArray.findIndex(obj => obj.quote_id === action.payload.id);
            let updatedItem = {
                ...newArray[existingIndex],
                tariffDetails: newArray[existingIndex].tariffDetails.map((item, innerIndex) => {
                    if (innerIndex === action.payload.index) {
                        return {
                            ...item,
                            fclTariffBreakDowns: item.fclTariffBreakDowns.map((subItem, subInnerIndex) => {
                                if (subInnerIndex === action.payload.subindex) {
                                    if (action.payload.name === 'markup_val' || "markup_type") {
                                        return {
                                            ...subItem,
                                            margin_value: action.payload.marginVal,
                                            total_sale_cost: action.payload.sales_cost,
                                            [action.payload.name]: action.payload.value,
                                        };
                                    } else {
                                        return {
                                            ...subItem,
                                            [action.payload.name]: action.payload.value
                                        };
                                    }
                                }
                                return subItem;
                            })
                        };
                    }
                    return item;
                })
            };
            newArray[existingIndex] = updatedItem;
            console.log(newArray, "newArray QUOTATION_RESULT_UPDATE");
            return {
                ...state,
                quote_selected_data: newArray
            };

        case QUOTATION_RESULT_REMARK_UPDATE:
            let newArrayRemark = [...state.quote_selected_data];
            const existingIndexRemark = newArrayRemark.findIndex(obj => obj.quote_id === action.payload.id);
            let updatedItemRemark = {
                ...newArrayRemark[existingIndexRemark],
                [action.payload.name]: action.payload.data
            };
            newArrayRemark[existingIndexRemark] = updatedItemRemark;
            return {
                ...state,
                quote_selected_data: newArrayRemark
            }

        case CONFIRM_PREVIEW_DATA:
            return {
                ...state,
                quote_selected_data: action.payload
            }

        case QUOTATION_RESULT_SELECTED_BLANK:
            return { ...state, quote_selected_data: [] }
        case POST_INSTANT_SEARCH_LOADER:
            return { ...state, result_loader: action.payload }

        // DOM Air
        case GET_INSTANT_AIR_SEARCH_RESULT_DETAILS:
            return {
                ...state,
                instantSearchResult: action.payload,
                instantSearchResultCopy: action.payload?.fclInquiryResults?.map((item, index) => ({
                    ...item,
                    tariffDetails: item.tariffDetails.map((item) => ({
                        ...item,
                        selected: true
                    }))
                })),
            }



        case FILTER_INSTANT_RATE:
            return { ...state, filter_instant_rate: action.payload }

        default:
            return state;
    }
}

export default instantRate;
